/**
 * patchFetch.ts — make every fetch send cookies.
 *
 * The license-acceptance cookie must ride ALL API requests. The app has no
 * shared fetch layer (each panel builds its own headers — dataApi, the
 * adapters, useSim, the chat runtime, the panels…), so instead of editing
 * every call site and hoping no future one forgets, we patch fetch once at
 * boot to default `credentials: 'include'`. Same-origin requests are
 * unaffected functionally; cross-origin ones (the app's normal topology —
 * browser origin vs the backend origin) now send cookies, which the backend's
 * CORS config already allows (allow_credentials=True). A caller that sets
 * `credentials` explicitly is left untouched.
 *
 * Call once from main.tsx, before anything issues a request.
 */

export function patchFetchWithCredentials(): void {
  const original = globalThis.fetch.bind(globalThis);
  globalThis.fetch = (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
    if (init?.credentials) return original(input, init);
    // init members override the corresponding properties of a Request input,
    // so this also covers the (currently unused) Request-object call style.
    return original(input, { ...init, credentials: 'include' });
  };
}
